// Helles/dunkles Design: Umschalter im Benutzermenü (Desktop) bzw. im Überlaufmenü (Handy/Tablet).
const THEME_KEY = 'prozessatlas:theme';

export function effectiveTheme() {
  const t = document.documentElement.getAttribute('data-theme');
  if (t) return t;
  return matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function toggleTheme(set: (t: string) => void) {
  const next = effectiveTheme() === 'dark' ? 'light' : 'dark';
  document.documentElement.setAttribute('data-theme', next);
  try { localStorage.setItem(THEME_KEY, next); } catch { /* egal */ }
  set(next);
}
